export function validateNegatives(value) {
  if (value && value < 0) {
    return 'Value should not be negative.';
  }
}
